import React from "react";
import { MainGrid } from "../UI/general";
import Footer from "./footer/footer";
import { Route } from "react-router-dom";
import Main from "./../Main/index";
import Dial from "./../Main/dial";
import Profile from "./../profile/index";
import History from "./../history/index";
function Dashboard(props) {
  console.log(props);
  return (
    <MainGrid>
      <div className="content">
        <Route path={`${props.match.path}/`} component={Main} exact></Route>
        <Route
          path={`${props.match.path}/profile`}
          component={Profile}
          exact
        ></Route>
        <Route path={`${props.match.path}/history`} component={History}></Route>
      </div>
      <Footer></Footer>
    </MainGrid>
  );
}
export default Dashboard;
